import getFormatedPrice from '../func/getFormatedPrice'

const getOtherFeesListItems = (dataKey, total, eventData, form_settings) => {

    const data = eventData[dataKey]
    const prices = eventData.prices[dataKey]
    const settings = form_settings[dataKey].items
    const items = []

    Object.keys(data).map(id => {
        const pro = '1' === settings[id].info.pro
        const name = settings[id].info.name
        const isNumber = "number" === settings[id].info.input
        const value = data[id]
        const price = prices[id]

        if(value) {
            if(isNumber) {
                if(pro) {
                    items.push(
                        <li key={id} className="container-3">
                            <span className="text-small-light">{name}:</span> 
                            <span className="text-small-light">{value} x {total} x {getFormatedPrice(price)}</span>
                            <span className="text-small-light">= {getFormatedPrice(value * total * price)}</span>
                        </li> 
                    )
                } else {
                    items.push(
                        <li key={id} className="container-3">
                            <span className="text-small-light">{name}:</span> 
                            <span className="text-small-light">{value} x {getFormatedPrice(price)}</span>
                            <span className="text-small-light">= {getFormatedPrice(value * price)}</span>
                        </li>
                    )
                }
            } else {
                if(pro)  {
                    items.push(
                        <li key={id} className="container-3">
                            <span className="text-small-light">{name}:</span>
                            <span className="text-small-light">{total} x {getFormatedPrice(price)}</span>
                            <span className="text-small-light">= {getFormatedPrice(total * price)}</span>
                        </li>
                    )
                   
                } else {
                    items.push(
                        <li key={id} className="container-3">
                            <span className="text-small-light">{name}:</span>
                            <span className="text-small-light">1 x {getFormatedPrice(price)} </span>
                            <span className="text-small-light">= {getFormatedPrice(price)}</span>
                        </li>
                    )
                }
            }
        }
    })

    return items
}

const EditEventFormPrintItem = ({dataKey, otherFeesKey, headline, eventData, form_settings}) => {
    const data = eventData[dataKey]
    const prices = eventData.prices[dataKey]
    const settings = form_settings[dataKey].items
    const isNumber = "visitors" === dataKey
    const items = []
    let total = 0
    

    Object.keys(data).map(id => {
        const value = data[id]
        const price = prices[id]
        const name =  settings[id].info.name

        if(!value) {
            return ''
        } else {
            const n = isNumber ? value : 1

            total += n

            items.push(
                <li key={id} className="container-3">
                    <span className="text-small-light">{name}:</span>
                    <span className="text-small-light">{n} x {getFormatedPrice(price)}</span>
                    <span className="text-small-light"> = {getFormatedPrice(n * price)}</span></li>
            )
        }
    })

    const otherFees = getOtherFeesListItems(otherFeesKey, total, eventData, form_settings)

    if(0 === items.length && 0 === otherFees.length) {
        return ''
    }

    return(
        <div className="margin-bottom-double">
            <p className="margin-bottom-half text-regular">{headline}</p>

            {items.length > 0 && <ul>{items}</ul>}

            {otherFees.length > 0 && <>
                <p className="margin-bottom-half margin-top-half text-small-regular">Weitere Gebühren</p>
                <ul>{otherFees}</ul>
            </>}
        </div>
    )
}

export default EditEventFormPrintItem